export const AUTH_SCOPES = ['openid', 'profile', 'offline_access', 'email'];

export const LOGIN_BASE_REQUEST = {
  scopes: AUTH_SCOPES,
};

export const TOKEN_BASE_REQUEST = {
  scopes: AUTH_SCOPES,
};
